export default __webpack_public_path__ + "static/SRF Carasweet 5SGF7702 - Product Specifications & Technical Data-6324b68ed3225a0576ebd81663f66f4b.pdf";